import { ReactNode } from 'react'
import styled from 'styled-components'

export const ChartFrame = ({
  title,
  sub,
  source,
  children,
}: {
  title?: string
  sub?: string
  source?: string
  children?: ReactNode
}) => {
  return (
    <StyledChartFrame>
      <div className='title'>{title && title}</div>
      <div className='sub'>{sub && sub}</div>
      {children && children}
      <div className='source'>{source && source}</div>
    </StyledChartFrame>
  )
}

const StyledChartFrame = styled.div`
  /* margin: 60px 0 30px 0; */
  /* min-height: 400px; */
  padding: 15px;
  padding-left: 0;
  padding-right: 0;
  font-family: var(--font-sans-serif);
  line-height: 1.5em;
  div.title {
    font-weight: 700;
    line-height: 1.3em;
    margin-bottom: 15px;
  }
  div.sub {
    margin-bottom: 30px;
    font-size: 15px;
    line-height: 1.5em;
  }
  div.source {
    margin-bottom: 30px;
    font-size: 12px;
    color: var(--gray-3);
    line-height: 1.5em;
  }
`
